import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { DepartmentsVm } from 'src/app/view-model/nav-departments/nav-departments.vm';
import { SessionEvent } from '../../../event-listeners/session/session.event';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';
import { PrimeEvent } from '../../../event-listeners/prime/prime.event';
import { SessionStorageManager } from 'src/app/data/manager/session-storage/session-storage.manager';

@Component({
  selector: 'app-prime-flag',
  templateUrl: './prime-flag.component.html',
  styleUrls: ['./prime-flag.component.scss']
})
export class PrimeFlagComponent implements OnInit{
  public primeConfig: any;
  public disabledPrime: boolean;
  public isPrime: boolean;
  public primeSubscription: any;
  public customer: any;

  public primeConfigSubscription: Subscription;

  constructor(
    private store: Store<AppState>,
    private vm: DepartmentsVm,
    private loginEvent: SessionEvent,
    private lsm: LocalStorageManager,
    private sessionStorageManager: SessionStorageManager,
    private primeEvent: PrimeEvent,
  ) {
    this.loginEvent.hasCustomer.subscribe(response => {
      this.customer = this.lsm.get("customer");
      this.isPrimeActive();
    });
  }

  get hasSessionValid(): boolean {
    return Boolean(this.customer?.customerId);
  } 
  
  ngOnInit(){
    this.getPrimeConfig();
    this.getPrimeSubscription();
    this.isPrimeActive();
    this.listenPrimeEvent();
  }

  listenPrimeEvent() {
    this.primeEvent.getPrimeUser.subscribe(response =>{
      if (response?.update) {
        this.sessionStorageManager.removeItem('primeSubscription');
        this.isPrimeActive();
      }
    });
  }

  getPrimeConfig(){
    this.primeConfigSubscription = this.store.select( 'prime' ).subscribe( ({config}) =>  this.primeConfig = config[0] );
  }

  getPrimeSubscription(){
    this.store.select('primeSubs').subscribe(({sub}) => {
      this.primeSubscription = sub;
      this.validateSubscription(sub?.expirationDate);
    });
  }

  async isPrimeActive() {
    this.vm.getPrimeSubscription(this.customer).subscribe( res =>{
      this.primeSubscription = res;
      this.validateSubscription( (res.expirationDate) ? res.expirationDate : '' );
    });
  }

  validateSubscription( expirationDate ){
    if(expirationDate){
      const today = new Date().getTime();
      ( expirationDate >= today) ? this.isPrime = true : this.isPrime = false;
    }
    if (this.primeConfig && !this.primeConfig.feature_active_web && !this.isPrime) {
      this.disabledPrime = true;
    } else {
      this.disabledPrime = false;
    }
  }

}
